module.exports = __webpack_public_path__ + "img/ads.6d6929c7.webp";